<template>
    <div style="width: 100%">
        <client-table></client-table>
    </div>
</template>

<script>
    const clientTable = ()=> import( '@/components/orgApps/Client/ClientTable');

    export default {
        name: "dashboard",
        components:{
            clientTable
        },
        data() {
            return { };
        },
        watch: {
            filters: {
                deep: true
            }
        },
        methods: {
            initialize() {
            },
        },
        async created(){
            this.initialize()
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>